module.exports = __webpack_public_path__ + "static/media/logo-dark.6ee2cd64.png";